import * as React from "react";

function SvgPlanetVenus(props) {
  return (
    <svg viewBox="0 0 100.01 100.01" {...props}>
      <defs>
        <radialGradient
          id="planet-venus_svg__d"
          cx={180.69}
          cy={-524.82}
          r={55.21}
          gradientTransform="matrix(.03 -.87 .9 -.16 485.91 96.53)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#f4f4f4" />
          <stop offset={0.67} stopColor="#515151" />
          <stop offset={1} />
        </radialGradient>
        <radialGradient
          id="planet-venus_svg__f"
          cx={180.69}
          cy={-524.82}
          r={55.21}
          gradientTransform="matrix(.03 -.87 .9 -.16 485.91 96.53)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#fff" />
          <stop offset={0.67} stopColor="#f7ebc2" />
          <stop offset={1} stopColor="#f3f9f7" />
        </radialGradient>
        <filter
          id="planet-venus_svg__a"
          x={4.19}
          y={-8201.69}
          width={59.48}
          height={32766}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <filter
          id="planet-venus_svg__c"
          x={4.19}
          y={5.88}
          width={59.48}
          height={58.9}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <mask
          id="planet-venus_svg__e"
          x={4.19}
          y={5.88}
          width={59.48}
          height={58.9}
          maskUnits="userSpaceOnUse"
        >
          <g
            mask="url(#planet-venus_svg__b)"
            filter="url(#planet-venus_svg__c)"
          >
            <path
              d="M15.8 16.45C28.41 4.33 48.57 2 59.13 12.83s1 20.64-11.1 35.62c-9.9 12.31-26.93 22.6-37.49 11.75S3.19 28.56 15.8 16.45z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#planet-venus_svg__d)"
            />
          </g>
        </mask>
      </defs>
      <g data-name="Layer 2">
        <circle
          cx={50.01}
          cy={50.01}
          r={50.01}
          transform="rotate(-20.14 49.99 50.003)"
          fill="#e2bf6d"
        />
        <path
          d="M50 100a50 50 0 0046.6-31.87C82.53 74.15 65 81 49.77 81.42c-6.38.19-12.79-.62-19.12.17-5 .63-10.13 2.48-13.68 5.94A49.82 49.82 0 0050 100z"
          fill="#e8914f"
        />
        <path
          d="M39.73 70.91a31.28 31.28 0 00-17.11-.12c-3.48 1-5.93 3.56-9.15 1.91a21.9 21.9 0 00-9.12-2.31A50.08 50.08 0 0012.48 83c.83-.25 1.64-.53 2.44-.85 5-2 9.52-4.9 14.54-6.72 6.36-2.32 13.22-2.76 20-3.18-1.99-2.8-6.91-3.25-9.73-1.34z"
          fill="#cf5636"
        />
        <path
          d="M99.87 46.4c-3.63 6-10.14 9.88-16.84 12.1-7.41 2.5-15.26 3.25-22.84 5.14-3.23.8-6.65 2-8.22 5.17a4.57 4.57 0 001.17 5.73 4.62 4.62 0 004.7.27 1.86 1.86 0 00-.34-3.54c-.63-2.21 1.19-4.54 3.39-5.2s4.57-.07 6.71.78a32.35 32.35 0 006.4 2.3c3.11.5 6.25-.4 9.26-1.29 5.61-1.67 11.46-3.47 15.61-7.6l.09-.1A50.64 50.64 0 00100 50c0-1.21 0-2.4-.13-3.6z"
          fill="#e8914f"
        />
        <path
          d="M98.75 38.87a49.55 49.55 0 00-4.59-12.34 65.85 65.85 0 01-49.89 21.72c-7.88-.19-15.81-1.81-23.57-.5C14.38 48.81 8.54 51.77 3 55a22.05 22.05 0 00-2.53 1.75A49 49 0 002.29 65C20 65.08 37.74 65 55 61.21c16.2-3.55 32.09-10.66 43.75-22.34z"
          fill="#cf5636"
        />
        <path
          d="M93.21 30.57a25.81 25.81 0 002-1.89A49.75 49.75 0 0090.74 21C88.27 26.58 85.49 31.69 80 34.43c-12.83 6.32-27.69 6.28-42 6.28-12.53 0-28.57-2.53-37.83 4.78C.08 47 0 48.48 0 50a50.5 50.5 0 00.87 9.27 8.85 8.85 0 011.19-.34A34.72 34.72 0 019 58.68a13.77 13.77 0 006.73-1.29c2-1.11 3.59-3.35 3.26-5.64 3.88-2.49 7.11-2.07 11.67-1.4s8.94 2.22 13.45 3.17A52.4 52.4 0 0068 53a5.06 5.06 0 002.88-1.52c.66-.89.5-2.44-.54-2.8 0-1.75 2.78-3.54 4.51-3.85s3.56-.11 5.19-.75c2.83-1.13 4.1-4.33 5.92-6.79 1.94-2.68 4.73-4.58 7.25-6.72z"
          fill="#e8914f"
        />
        <path
          d="M78.57 9c-9 6.72-21.39 7.83-32.79 7.22-10.55-.55-21.24-2.24-31.65-1A50 50 0 002.31 35a50.28 50.28 0 0133.6-7.88c7 .88 13.88 3.28 21 3.51a35.44 35.44 0 0022.41-7.2c2.72-2.07 5.26-4.73 5.92-8.09a5.62 5.62 0 00.1-.7A50.26 50.26 0 0078.57 9z"
          fill="#d9a66a"
        />
        <path
          d="M76.32 7.49A44.14 44.14 0 0159 13c-9.67 1.1-19.42-.1-29.14-.5a94.66 94.66 0 00-13.15.25q-1.85 1.65-3.51 3.47c6-1.08 12.53-.73 18.62-.22 10.49.87 21.18 2.91 31.42.48A55.5 55.5 0 0079.46 9.6c-1.02-.74-2.06-1.45-3.14-2.11z"
          fill="#e8914f"
        />
        <path
          d="M69.1 22.7c.22 1.15-2.12 2.56-5.22 3.15s-5.79.14-6-1S60 22.29 63.1 21.7s5.78-.15 6 1z"
          fill="#ef633f"
          opacity={0.75}
        />
        <path
          d="M92.85 35.45c.46.43.18 1.47-.63 2.32s-1.83 1.19-2.29.76-.17-1.48.63-2.33 1.83-1.2 2.29-.75z"
          fill="#ffdf9c"
        />
        <ellipse cx={24.32} cy={59.51} rx={3.43} ry={1.63} fill="#ffdf9c" />
        <path
          d="M61.47 24.74l2.25-.14a5.38 5.38 0 002.28-.5c.36-.2.7-.6.55-1s-.61-.43-1-.43A10.43 10.43 0 0061 23.78c-.21.11-.45.26-.45.5s.55.48.92.46z"
          fill="#ffdf9c"
        />
        <path
          d="M24.63 58.94a3.11 3.11 0 00-2.33 1 3.09 3.09 0 002.61.4c.35-.1.74-.35.74-.73s-.57-.67-1.02-.67z"
          fill="#beb988"
        />
        <path
          d="M76.58 70.14c0-3.86 3.23-6.87 6.16-9.38l6.2-5.31c3-2.61 9-6 8.81-10a56.51 56.51 0 01-3.17 21.31c-2.31 7-8.35 14.45-14.19 19-6.92 5.4-15.7 7.71-24.25 9.7-4.53 1.06-9.13 2.07-13.78 1.87S33 95.56 29.78 92.16c-1.53-1.65-2.54-4.5-.83-6a3.62 3.62 0 013.53-.39 29.48 29.48 0 013.31 1.69 11.26 11.26 0 008.8.42 5.47 5.47 0 0010.13-3.79c-.21-1-.73-2-.95-3a2.86 2.86 0 01.76-2.91c1.42-1.07 3.32.24 4.89 1.06 3.12 1.65 6.87 1.27 10.38.84 2.71-.32 5.92-1 6.93-3.55.8-2-.17-4.24-.15-6.39z"
          fill="#cf5636"
        />
        <path
          d="M74.74 57.16a1.07 1.07 0 00.79 1.27 3.22 3.22 0 001.65-.11l7.45-1.89a5.91 5.91 0 003-1.43c1.35-1.47.88-3.78 1.29-5.74a1.59 1.59 0 00-1.78.48 15 15 0 00-1.1 1.63c-1.06 1.49-2.87 2.22-4.58 2.86l-5.72 2.16c-.39.16-.85.36-1 .77zM23.75 68.62a1.92 1.92 0 001.14.12l7.28-.74-.24-1.19a10.61 10.61 0 00-6.47-.94 3 3 0 00-1.89.89 1.29 1.29 0 00.18 1.86zM48.39 74.93a2.72 2.72 0 00-1.24-.13q-5.73.32-11.41 1.13a3.09 3.09 0 00-1.3.4 1.05 1.05 0 00-.44 1.19 1.53 1.53 0 00.86.67 23.89 23.89 0 006.74 2.2 8.1 8.1 0 006.62-1.88 3.15 3.15 0 001-1.8 1.69 1.69 0 00-.83-1.78zM68.73 33.58a1.61 1.61 0 001 .46c3.23.53 6.48-.61 9.53-1.77a14.7 14.7 0 004.61-2.45 5.06 5.06 0 001.8-4.66c-.23-1-1.07-2-2.1-1.9a3.4 3.4 0 00-1.92 1.27c-3.22 3.2-7.78 4.56-11.75 6.75a3.24 3.24 0 00-1.16.91 1.2 1.2 0 00-.01 1.39z"
          fill="#e8914f"
        />
        <path
          d="M12.3 17.25a41.33 41.33 0 11-2.65 3.33 50 50 0 102.65-3.33z"
          fill="#ef633f"
          opacity={0.34}
        />
        <path
          d="M86.44 84.2A50 50 0 0084 13.42c-.22-.2-.31 0-.53-.2a51.86 51.86 0 01-67 73.94 49.84 49.84 0 0028.38 12.59h.73c.54 0 1.08.1 1.62.13s1.28 0 1.92.06h.42a50.13 50.13 0 0036.9-15.74z"
          style={{
            mixBlendMode: "multiply",
          }}
          fill="#cfa195"
        />
        <path
          d="M0 50a49.87 49.87 0 004.53 20.8C22.31 75.39 40.5 69.5 54 55.2 68 40.37 73 20.48 66.27 2.72A50 50 0 000 50z"
          fill="#fff"
          opacity={0.15}
        />
        <g mask="url(#planet-venus_svg__e)">
          <path
            d="M15.8 16.45C28.41 4.33 48.57 2 59.13 12.83s1 20.64-11.1 35.62c-9.9 12.31-26.93 22.6-37.49 11.75S3.19 28.56 15.8 16.45z"
            opacity={0.57}
            fill="url(#planet-venus_svg__f)"
          />
        </g>
        <path
          d="M27.78 94.8a50 50 0 101.61-90.35A49.23 49.23 0 0191.85 73a49.71 49.71 0 01-64.07 21.8z"
          style={{
            mixBlendMode: "screen",
          }}
          fill="#fff"
          opacity={0.24}
        />
      </g>
    </svg>
  );
}

export default SvgPlanetVenus;
